module.exports = __webpack_public_path__ + "static/media/room6.41088464.png";